
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Corporatecabstaxibanglore() {



    const cardData =
    {
        keyword: '  Corporate Cabs Taxi Bangalore',
        heading: 'etravo : Corporate Cabs Taxi Bangalore',



"headingDescription": "eTravo offers reliable Corporate Cabs and Taxi Services in Bangalore, designed for IT companies, MNCs, startups, and professionals who require seamless transportation for daily office commute, employee pickup and drop, airport transfers, client meetings, and executive travel. With GPS-enabled vehicles, trained chauffeurs, and flexible corporate plans, eTravo ensures safe, punctual, and comfortable mobility across Bangalore’s key business corridors.",

"top": "Top Corporate Taxi Service Zones in Bangalore with eTravo",

"topPlaces": [
  {
    "title": "Electronic City",
    "description": "A major IT hub in Bangalore with large tech parks and corporate offices requiring structured employee taxi services and shift-based transportation."
  },
  {
    "title": "Whitefield",
    "description": "One of the biggest corporate zones in Bangalore with MNCs and IT parks requiring daily cab and taxi services for employees."
  },
  {
    "title": "Outer Ring Road (ORR)",
    "description": "A key IT corridor connecting multiple tech parks and corporate offices with high demand for taxi-based employee transport."
  },
  {
    "title": "Manyata Tech Park",
    "description": "A large IT park in North Bangalore where corporate taxi services are widely used for daily employee commute."
  },
  {
    "title": "Koramangala",
    "description": "A startup and corporate hub with offices and co-working spaces requiring flexible taxi services for professionals."
  },
  {
    "title": "HSR Layout",
    "description": "A residential and commercial zone where professionals depend on corporate taxi services for daily commuting."
  },
  {
    "title": "Marathahalli",
    "description": "A busy IT corridor connecting multiple tech parks requiring reliable taxi services for employees."
  },
  {
    "title": "Hebbal",
    "description": "A fast-developing business hub near the airport with corporate offices requiring executive taxi services."
  },
  {
    "title": "Indiranagar",
    "description": "A premium commercial and residential area with corporate offices and client meeting locations."
  },
  {
    "title": "Bangalore Airport (Devanahalli) Corridor",
    "description": "A key route for airport transfers, executive travel, and corporate taxi services connecting business hubs."
  }
],


"services": [
{
"name": "Corporate Cabs Bangalore",
"description": "eTravo offers reliable corporate cabs in Bangalore designed for smooth and professional business travel. Our service ensures punctual pickups, comfortable rides, and experienced chauffeurs for daily office commuting and executive travel."
},
{
"name": "Corporate Taxi Bangalore",
"description": "Our corporate taxi services in Bangalore provide efficient and flexible transportation for businesses. eTravo ensures timely service, clean vehicles, and a seamless travel experience for executives and employees."
},
{
"name": "Company Cab Hire Bangalore",
"description": "eTravo provides company cab hire services in Bangalore tailored for corporate needs. From employee transport to executive travel, our service ensures reliability, safety, and smooth operations."
},
{
"name": "Office Cab Bangalore",
"description": "Simplify daily commuting with eTravo’s office cab services in Bangalore. We offer structured and dependable transportation solutions for employees across IT parks and business hubs."
},
{
"name": "Employee Transport Bangalore",
"description": "Our employee transport services in Bangalore are designed for safe and punctual workforce mobility. eTravo ensures well-planned routes and comfortable rides for daily commuting."
},
{
"name": "Corporate Travel Cab Bangalore",
"description": "eTravo offers corporate travel cab services in Bangalore for both local and outstation needs. Our service ensures smooth and reliable travel for executives and business teams."
},
{
"name": "Business Taxi Bangalore",
"description": "eTravo’s business taxi services in Bangalore are ideal for meetings, client visits, and corporate activities. Our service focuses on punctuality, comfort, and professional travel experiences."
},
{
"name": "Staff Cab Bangalore",
"description": "eTravo provides dependable staff cab services in Bangalore for daily employee commuting. Our service ensures timely pickups, safe travel, and efficient coordination."
},
{
"name": "Corporate Fleet Bangalore",
"description": "eTravo offers corporate fleet services in Bangalore for businesses requiring multiple vehicles. Our fleet ensures consistent quality, proper maintenance, and smooth transportation operations."
},
{
"name": "Company Taxi Bangalore",
"description": "Our company taxi services in Bangalore provide flexible and convenient transport options for businesses. eTravo ensures reliable travel for employees, clients, and executives."
},
{
"name": "Corporate Pickup Drop Bangalore",
"description": "eTravo provides corporate pickup and drop services in Bangalore for efficient employee commuting. Our service ensures punctual scheduling and comfortable travel experiences."
},
{
"name": "Business Travel Cab Bangalore",
"description": "Our business travel cab services in Bangalore are designed for professionals traveling for meetings and corporate activities. eTravo ensures smooth, reliable, and comfortable journeys."
},
{
"name": "Office Commute Cab Bangalore",
"description": "eTravo offers office commute cab services in Bangalore for daily employee travel. Our service ensures punctual pickups, comfortable rides, and smooth commuting experiences."
},
{
"name": "Corporate Cab Booking Bangalore",
"description": "eTravo makes corporate cab booking in Bangalore simple and convenient. Our service ensures reliable vehicles, easy scheduling, and hassle-free travel for businesses."
},
{
"name": "Professional Taxi Bangalore",
"description": "eTravo provides professional taxi services in Bangalore with trained drivers and well-maintained vehicles. Our service ensures safe, comfortable, and reliable travel for corporate clients."
}
],
"tableData": [
["Corporate Cabs Bangalore", "Corporate Taxi Bangalore"],
["Company Cab Hire Bangalore", "Office Cab Bangalore"],
["Employee Transport Bangalore", "Corporate Travel Cab Bangalore"],
["Business Taxi Bangalore", "Staff Cab Bangalore"],
["Corporate Fleet Bangalore", "Company Taxi Bangalore"],
["Corporate Pickup Drop Bangalore", "Business Travel Cab Bangalore"],
["Office Commute Cab Bangalore", "Corporate Cab Booking Bangalore"],
["Professional Taxi Bangalore", ""]
],




"whychoose": [
    {
      "WhyChooseheading": "Reliable Corporate Cabs Taxi Bangalore Services",
      "WhyChoosedescription": "eTravo offers professional corporate cabs taxi services in Bangalore, ensuring smooth and efficient transportation for employees, executives, and business clients across major IT hubs like Whitefield, Electronic City, and Outer Ring Road."
    },
    {
      "WhyChooseheading": "Complete Corporate Taxi Solutions for Businesses",
      "WhyChoosedescription": "Corporate taxi services in Bangalore include employee transportation, airport transfers, executive travel, and long-term rentals, providing end-to-end mobility solutions for companies. :contentReference[oaicite:0]{index=0}"
    },
    {
      "WhyChooseheading": "On-Time Pickup and Drop for Employees",
      "WhyChoosedescription": "Structured schedules and optimized routes ensure employees reach offices on time, improving productivity and reducing travel delays in Bangalore traffic. :contentReference[oaicite:1]{index=1}"
    },
    {
      "WhyChooseheading": "Wide Fleet of Corporate Taxi Vehicles",
      "WhyChoosedescription": "Corporate cab providers offer hatchbacks, sedans, SUVs, and larger vehicles suitable for daily office commute, team travel, and executive transportation. :contentReference[oaicite:2]{index=2}"
    },
    {
      "WhyChooseheading": "Professional Chauffeurs and Safety Standards",
      "WhyChoosedescription": "Trained drivers with corporate etiquette and safety protocols ensure secure, comfortable, and professional travel experiences for employees and executives."
    },
    {
      "WhyChooseheading": "Technology-Enabled Fleet and Tracking",
      "WhyChoosedescription": "Modern corporate taxi services use GPS tracking, route optimization, and real-time monitoring systems to improve safety and efficiency in employee transportation. :contentReference[oaicite:3]{index=3}"
    },
    {
      "WhyChooseheading": "Flexible Monthly and Contract-Based Plans",
      "WhyChoosedescription": "Corporate taxi services offer flexible plans including daily pickup-drop, monthly contracts, and long-term rentals tailored to business needs. :contentReference[oaicite:4]{index=4}"
    },
    {
      "WhyChooseheading": "24/7 Support for Corporate Travel Needs",
      "WhyChoosedescription": "Round-the-clock support ensures seamless coordination, quick issue resolution, and uninterrupted corporate mobility for businesses operating in Bangalore. :contentReference[oaicite:5]{index=5}"
    }
  ]

}

const faqData = [
    [
        {
            question: 'What are corporate cabs taxi services in Bangalore?',
            answer: 'Corporate cabs taxi services in Bangalore provide organized transportation for employees, executives, and clients including daily office commute, airport transfers, and business travel.',
        },
        {
            question: 'What services are included in corporate taxi services?',
            answer: 'Services include employee transport, airport pickup and drop, executive travel, and long-term corporate rentals. :contentReference[oaicite:6]{index=6}',
        },
        {
            question: 'Do corporate cabs provide daily pickup and drop services?',
            answer: 'Yes, services include structured daily pickup and drop with optimized routes and schedules for employees. :contentReference[oaicite:7]{index=7}',
        },
        {
            question: 'Are corporate taxi services available 24/7 in Bangalore?',
            answer: 'Yes, most corporate cab providers operate round the clock to support business travel and shift-based operations. :contentReference[oaicite:8]{index=8}',
        },
        {
            question: 'What types of vehicles are available for corporate travel?',
            answer: 'Vehicles include hatchbacks, sedans, SUVs, tempo travellers, and luxury cars depending on employee and executive travel needs. :contentReference[oaicite:9]{index=9}',
        },
        {
            question: 'Are corporate cab services safe for employees?',
            answer: 'Yes, services include GPS tracking, verified drivers, and safety protocols ensuring secure travel for employees. :contentReference[oaicite:10]{index=10}',
        },
        {
            question: 'Can corporate travel plans be customized?',
            answer: 'Yes, companies can customize routes, schedules, and rental plans based on workforce requirements.',
        },
        {
            question: 'Do corporate cab services offer monthly contracts?',
            answer: 'Yes, companies can opt for monthly and long-term corporate transport contracts for cost-effective commuting. :contentReference[oaicite:11]{index=11}',
        },
        {
            question: 'Do corporate taxi services provide airport transfers?',
            answer: 'Yes, corporate taxi services include airport pickup and drop for employees, executives, and business clients. :contentReference[oaicite:12]{index=12}',
        },
        {
            question: 'How can I book corporate cabs taxi services in Bangalore?',
            answer: 'You can book through the service provider’s website or contact their support team for customized corporate travel solutions.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Vikram Rao',
        designation: 'Operations Manager, IT Company, Bangalore',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo provides excellent corporate taxi services in Bangalore. Their punctual pickups and professional drivers ensure smooth daily operations.”',
    },
    {
        name: 'Ms. Ananya Shetty',
        designation: 'HR Manager, Tech Firm, Bangalore',
        rating: [1, 1, 1, 1, 1],
        text: '“We rely on eTravo for employee transportation in Bangalore. Their flexible plans and reliable service make commuting easy and stress-free.”',
    },
];



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cabs Taxi Bangalore",
  "image": "https://www.etravo.in/images/keyword/corporate-cabs-taxi-bangalore.jpg",
  "description": "Reliable corporate cab and taxi services in Bangalore by eTravo. Ideal for employee transport, office commute, business travel, corporate pickup and drop, and professional fleet management.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "1250"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2199",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/corporate-cabs-taxi-bangalore"
  }
};







    return (
        <div>
<Helmet>
  <title>Corporate Cabs Taxi Bangalore | Office & Employee Transport | eTravo</title>
  <meta 
    name="description" 
    content="Book corporate cabs and taxi services in Bangalore with eTravo for employee transport, office commute, business travel, and corporate pickup and drop services. Reliable and safe rides." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/151.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Corporatecabstaxibanglore;